import React from "react";
import { Link } from "react-router-dom";
import "./topbar.css"
const user=false;

class Topbar extends React.Component{
    constructor(){
        super();
            this.state ={
                display: 'none',
            }
        }
            show=()=>{
                this.setState({display:'block'})
            }
            hide=()=>{
                this.setState({display:'none'})
            }
    render (){
        const {display} = this.state;
        return(
        <div className="top">
            <div className="topleft">
                <i className="topicon fa-brands fa-facebook"></i>
                <i className="topicon fa-brands fa-instagram"></i>
                <i className="topicon fa-brands fa-twitter"></i>
                <i className="topicon fa-brands fa-pinterest"></i>
               
                 </div>
            <div className="topcentre">
                <ul className="toplist">
                    <li className="toplistitem"><Link className="Link" to="/">HOME</Link></li>
                    <li className="toplistitem"><Link className="Link" to="/post/:postid">ABOUT</Link></li>
                    <li className="toplistitem"><Link className="Link" to="/settings">CONTACT</Link></li>
                    <li className="toplistitem"><Link className="Link" to="/write">WRITE</Link></li>
                    <li className="toplistitem">{user && "LOGOUT"}</li>


                </ul>
                
            </div>
            <div className="topright">
                {
                    user ?(<img className="topimg" src="../assests/travel1.jpg" alt=""/>

                    ):(
                     <ul className="toplist">
                         <li className="toplistitem"><Link className="Link" to="/login">LOGIN</Link></li>
                    <li className="toplistitem"><Link className="Link" to="/register">REGISTER</Link></li>
                     </ul>
                       
                        
                    )
                }
               
                <i className="topsearchicon fa-solid fa-magnifying-glass"></i>
                <i class="topsearchicon1 fa fa-bars" aria-hidden="true" onClick={this.show}></i>
            </div>
            <div className="menu" style={{display:display}} >
                <ul className="toplist1">
                    <li className="toplistitem1"><Link className="Link" to="/">HOME</Link></li>
                    <li className="toplistitem1"><Link className="Link" to="/post/:postid">ABOUT</Link></li>
                    <li className="toplistitem1"><Link className="Link" to="/settings">CONTACT</Link></li>
                    <li className="toplistitem1"><Link className="Link" to="/write">WRITE</Link></li>
                    <li  type="button" className="toplistitem1" onClick={this.hide}>Close</li>


                </ul>
                
            </div>
        </div>
)}
}
export default Topbar;
